import { Routes, Route } from 'react-router-dom';
import { AppProvider, useApp } from './context/AppContext';
import { usePhotoStream } from './hooks/usePhotoStream';
import PreWeddingView from './components/PreWeddingView';
import PostWeddingView from './components/PostWeddingView';
import GalleryView from './components/GalleryView';
import GuestInfoView from './components/GuestInfoView';
import UploadModal from './components/UploadModal';
import PhotoModal from './components/PhotoModal';

function AppContent() {
  const { viewMode, isUploadModalOpen, selectedPhotoId } = useApp();
  
  // Set up real-time photo stream
  usePhotoStream();

  return (
    <div className="min-h-screen bg-autumn-cream">
      <Routes>
        <Route path="/gallery" element={<GalleryView />} />
        <Route path="/info" element={<GuestInfoView />} />
        <Route
          path="*"
          element={
            viewMode === 'countdown' ? (
              <PreWeddingView />
            ) : (
              <PostWeddingView />
            )
          }
        />
      </Routes>
      
      {/* Modals */}
      {isUploadModalOpen && <UploadModal />}
      {selectedPhotoId && <PhotoModal />}
    </div>
  );
}

function App() {
  return (
    <AppProvider>
      <AppContent />
    </AppProvider>
  );
}

export default App;

